(function () {
  const prodcarousel = () => {
    $('.product-carousel-section').each(function () {
      const slideEl = $(this).find('.product-carousel__wrapper')
      const carousel = $(this).find('.swiper-carousel')
      const slide = $(this).find('.swiper-slide')
      const buttonNext = $(this).find('.swiper-button-next')
      const prodCountHalf = parseFloat(slideEl.data('count')) + 0.1
      if ($(this).hasClass('slider_started')) {
        return ''
      }

      $(this).addClass('slider_started')
      const id = $(this).attr('id')

      const prodSwiperParams = {
        centeredSlides: false,
        slidesPerView: 2.1,
        waitForTransition: false,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 4,
        breakpoints: {
          1200: {
            slidesPerView: 3.1,
          },
          1360: {
            slidesPerView: prodCountHalf,
          },
        },
        on: {
          slideChange () {
            if (this.activeIndex === 0) {
              Array.from(slide).forEach((element) => {
                element.classList.remove('slide_change-postion')
              })
              Array.from(carousel).forEach((element) => {
                element.classList.add('carousel_change-postion_next')
                element.classList.remove('carousel_change-postion_prev')
                element.classList.remove('carousel_change-postion_next-2')
              })
              this.update()
            } else {
              if (this.activeIndex > this.previousIndex) {
                Array.from(carousel).forEach((element) => {
                  element.classList.remove('carousel_change-postion_next')
                  element.classList.remove('carousel_change-postion_next-2')
                  element.classList.add('carousel_change-postion_prev')
                })
                Array.from(slide).forEach((element) => {
                  if (buttonNext.hasClass('swiper-button-disabled')) {
                    element.classList.remove('slide_change-postion')
                  } else {
                    element.classList.add('slide_change-postion')
                  }
                })
              } else {
                Array.from(carousel).forEach((element) => {
                  element.classList.add('carousel_change-postion_next-2')
                  element.classList.remove('carousel_change-postion_prev')
                })
                Array.from(slide).forEach((element) => {
                  element.classList.remove('slide_change-postion')
                })
              }
              this.update()
            }
          },
        },
      }

      const swiperSlider = new Swiper(`#${id} .swiper-carousel`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next__prod`,
          prevEl: `#${id} .swiper-button-prev__prod`,
        },
        pagination: {
          el: `#${id} .product_carousel_pagination`,
          clickable: true,
          renderBullet (index, className) {
            return `<span class="${className}">` + `</span>`
          },
        },
        ...prodSwiperParams,
      })
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    prodcarousel()
  })

  document.addEventListener('shopify:section:load', () => {
    prodcarousel()
  })

  document.addEventListener('resize', () => {
    prodcarousel()
  })

  document.addEventListener('visibilitychange', () => {
    prodcarousel()
  })

  prodcarousel()
})()

// button-with-underline
if (window.screen.width > 990) {
  let attachedProductCarousel = false

  const carouselSection = document.querySelector('.product-carousel-section')

  const imageContainerCarousel = carouselSection.querySelector(
    '.button--with-underline--container',
  )

  const followMouseCarousel = (event) => {
    if (imageContainerCarousel) {
      imageContainerCarousel.style.left = `${event.pageX}px`
      imageContainerCarousel.style.top = `${event.pageY + 30}px`
    }
  }

  function showTextCarousel () {
    if (!attachedProductCarousel && imageContainerCarousel) {
      attachedProductCarousel = true
      imageContainerCarousel.style.display = 'block'
      document.addEventListener('pointermove', followMouseCarousel)
    }
  }

  function hideTextCarousel () {
    if (imageContainerCarousel) {
      attachedProductCarousel = false
      imageContainerCarousel.style.display = ''
      document.removeEventListener('pointermove', followMouseCarousel)
    }
  }
}